import React, { lazy, Suspense } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import {
  capitalizeFirstLetter,
  formatPhoneNumber,
  addInternationalCode,
} from "../Utils/index.js";
import parser from "html-react-parser";
import "./staff.css";

const handleButtonClick = (ssid) => {
  // Replace 'https://example.com' with the URL you want to open.
  window.open("https://www.swmc.com/ApplyNow/?lof=" + ssid + "", "_blank");
};

export default function Staff({ realtorData, loanOfficerActive, loanOfficerData, angelAiUserInfo }) {

  const loanOfficerName = loanOfficerData ? capitalizeFirstLetter(loanOfficerData.name) : "";
  const loanOfficerPhoneNumber = loanOfficerData ? (loanOfficerData.mobilePhoneNumber ? loanOfficerData.mobilePhoneNumber : loanOfficerData.workPhoneNumber) : "";
  const loanOfficerPhoneNumberFormatted = loanOfficerData ? formatPhoneNumber(loanOfficerPhoneNumber) : "";
  const loanOfficerPhoneNumberWithInternationalCode = loanOfficerData ? addInternationalCode(loanOfficerPhoneNumber, "+1") : "";
  const loanOfficerPhoneNumberInTitle = loanOfficerData ? "Contact me at " + loanOfficerPhoneNumberFormatted : "";

  const realtorName = realtorData ? capitalizeFirstLetter(realtorData.name) : "";
  const realtorPhoneNumber = realtorData ? (realtorData.mobilePhoneNumber ? realtorData.mobilePhoneNumber : realtorData.workPhoneNumber) : "";
  const realtorPhoneNumberFormatted = realtorData ? formatPhoneNumber(realtorPhoneNumber) : "";
  const realtorPhoneNumberWithInternationalCode = realtorData ? addInternationalCode(realtorPhoneNumber, "+1") : "";
  const realtorPhoneNumberInTitle = realtorData ? "Contact me at " + realtorPhoneNumberFormatted : "";

  return (
    <>
      <div className="staffContainer">
        <Container>
          <Row>
            {/* First Column - loan officer data*/}
            <Col sm={12} md={12} lg={5} xl={5} className="borderofjoa">
              {/* Replace 'imageURL' with the path to your image */}
              <div className="columnStyle">
                {loanOfficerActive && loanOfficerData ? (
                  <img src={loanOfficerData.logo}
                    className="imageStyle loImageStyle"
                    alt={'Loan Officer Company Logo'} />
                ) : (
                  <>
                    {angelAiUserInfo ?
                      <a
                        href={angelAiUserInfo.angelAIBrandingInfo.webAppURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={angelAiUserInfo.angelAIBrandingInfo.brandName}
                        aria-label={angelAiUserInfo.angelAIBrandingInfo.brandName}
                      >
                        <img
                          src={angelAiUserInfo.angelAIBrandingInfo.brandLogoHorizontal}
                          className="imageStyle loImageStyle"
                          alt={angelAiUserInfo.angelAIBrandingInfo.brandName}
                        />
                      </a>
                      : ""}
                  </>
                )}

              </div>
              <div className="mortgageofficer loOfficer">
                <>
                  <div >
                    <Row className="joaquinrow">
                      <Col sm={12} md={12} xl={4} lg={4}>
                        <div className="joaquinsec">
                          {loanOfficerActive && loanOfficerData ? (
                            <img
                              src={loanOfficerData.profileImage}
                              className="profileImg img-fluid"
                              alt={loanOfficerName}
                            />
                          ) : (
                            <>
                              {angelAiUserInfo ?
                                <a
                                  href={angelAiUserInfo.angelAIBrandingInfo.webAppURL}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title={angelAiUserInfo.angelAIBrandingInfo.brandName}
                                  aria-label={angelAiUserInfo.angelAIBrandingInfo.brandName}
                                >
                                  <img
                                    src={angelAiUserInfo.angelAIBrandingInfo.brandLogoHorizontal}
                                    className="profileImg img-fluid"
                                    alt={angelAiUserInfo.angelAIBrandingInfo.brandName}
                                  />
                                </a>
                                : ""}
                            </>
                          )}
                        </div>
                      </Col>
                      <Col sm={12} md={12} xl={8} lg={8}>
                        {loanOfficerActive && loanOfficerData ? (
                          <>
                            <div className="introtext">
                              <h6 className="lo-name">{loanOfficerName}</h6>
                              <p className="joainfo">
                                {loanOfficerData.nmls ? (
                                  <>
                                    {'NMLS ' + loanOfficerData.nmls}
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                {loanOfficerData.designation ? (
                                  <>
                                    {loanOfficerData.designation}
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                {loanOfficerPhoneNumber ? (
                                  <>
                                    <a
                                      href={"tel:" + loanOfficerPhoneNumberWithInternationalCode}
                                      title={loanOfficerPhoneNumberInTitle}
                                      aria-label={loanOfficerPhoneNumberInTitle}
                                    >
                                      {'D: ' + loanOfficerPhoneNumberFormatted}
                                    </a>
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                {loanOfficerData.emailAddress ? (
                                  <>
                                    <a
                                      href={"mailto:" + loanOfficerData.emailAddress}
                                      title={"Email me at " + loanOfficerData.emailAddress}
                                      aria-label={"Email me at " + loanOfficerData.emailAddress}
                                    >
                                      {loanOfficerData.emailAddress}
                                    </a>
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                {loanOfficerData.userWebsite ? (
                                  <>
                                    <a
                                      href={loanOfficerData.userWebsite}
                                      title={loanOfficerData.userWebsite}
                                      aria-label={loanOfficerData.userWebsite}
                                      target="_blank"
                                    >
                                      {loanOfficerData.userWebsite.replace("https://", "")}
                                    </a>
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                {loanOfficerData.streetAddress ? (
                                  <>
                                    <a
                                      href={`https://maps.google.com/?q=${loanOfficerData.streetAddress} ${loanOfficerData.cityStateZip}`}
                                      target="_blank"
                                    >
                                      {loanOfficerData.streetAddress}
                                      <br></br>
                                      {loanOfficerData.cityStateZip}
                                    </a>
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                {loanOfficerData.branchNMLS ? (
                                  <>
                                    {loanOfficerData.branchNMLS}
                                  </>
                                ) : (
                                  ""
                                )}
                              </p>
                            </div>
                          </>
                        ) : (
                          <>
                            {angelAiUserInfo ?
                              <div className="lo-name-nmls-d">
                                <p className="joainfo angelAiInfo">
                                  {angelAiUserInfo.angelAIUserInfo.workPhoneNumber ? (
                                    <>
                                      Call us at <a
                                        href={"tel:" + addInternationalCode(angelAiUserInfo.angelAIUserInfo.workPhoneNumber, "+1")}
                                        title={formatPhoneNumber(angelAiUserInfo.angelAIUserInfo.workPhoneNumber)}
                                        aria-label={formatPhoneNumber(angelAiUserInfo.angelAIUserInfo.workPhoneNumber)}
                                      >
                                        {'D: ' + formatPhoneNumber(angelAiUserInfo.angelAIUserInfo.workPhoneNumber)}
                                      </a>
                                      <br></br>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                  {angelAiUserInfo.angelAIUserInfo.email ? (
                                    <>
                                      Email us at <a
                                        href={"mailto:" + angelAiUserInfo.angelAIUserInfo.email}
                                        title={angelAiUserInfo.angelAIUserInfo.email}
                                        aria-label={angelAiUserInfo.angelAIUserInfo.email}
                                      >
                                        {angelAiUserInfo.angelAIUserInfo.email}
                                      </a>
                                      <br></br>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </p>
                              </div>
                              : ""}
                          </>
                        )}
                      </Col>
                    </Row>
                  </div>
                </>
              </div>
            </Col>
            {/* Second Column - Apply Button */}
            <Col className="applycol" sm={12} md={12} lg={2} xl={2} >
              <div className="applybtn text-center mb-3">
                <Button
                  variant="primary"
                  className="applyNowBtn staffApplyBtn"
                  onClick={() => handleButtonClick(loanOfficerData.ssid)}
                >
                  Apply Now
                </Button>
              </div>
            </Col>

            {/* Third Column - Realtor data*/}
            <Col sm={12} md={12} lg={5} xl={5} className="borderofjoa borderOfRealtor">
              <div className="mortgageofficer">
                <div className="columnStyle">
                  <img src={realtorData.logo}
                    className="imageStyle realtorLogoStyle"
                    alt={'Realtor Company Logo'} />
                </div>
                <>
                  <div >
                    <Container>
                      {realtorData ? (
                        <Row className="joaquinrow colRealtor">
                          <Col sm={12} md={12} xl={8} lg={8} className="colRealtorDetails">
                            <div className="realtorIntrotext">
                              <h6 className="lo-name">{realtorName}</h6>
                              <p className="joainfo">
                                {realtorData.license ? (
                                  <>
                                    {'License ' + realtorData.license}
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                {realtorData.designation ? (
                                  <>
                                    {realtorData.designation.includes('®') ? <span>{realtorData.designation}</span> : <>{realtorData.designation}</>}
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                {realtorPhoneNumber ? (
                                  <>
                                    <a
                                      href={"tel:" + realtorPhoneNumberWithInternationalCode}
                                      title={realtorPhoneNumberInTitle}
                                      aria-label={realtorPhoneNumberInTitle}
                                    >
                                      {'D: ' + realtorPhoneNumberFormatted}
                                    </a>
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                {realtorData.emailAddress ? (
                                  <>
                                    <a
                                      href={"mailto:" + realtorData.emailAddress}
                                      title={"Email me at " + realtorData.emailAddress}
                                      aria-label={"Email me at " + realtorData.emailAddress}
                                    >
                                      {realtorData.emailAddress}
                                    </a>
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                {realtorData.userWebsite ? (
                                  <>
                                    <a
                                      href={realtorData.userWebsite}
                                      title={realtorData.userWebsite}
                                      aria-label={realtorData.userWebsite}
                                      target="_blank"
                                    >
                                      {realtorData.userWebsite.replace("https://", "")}
                                    </a>
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                {realtorData.streetAddress ? (
                                  <>
                                    <a
                                      href={`https://maps.google.com/?q=${realtorData.streetAddress} ${realtorData.cityStateZip}`}
                                      target="_blank"
                                    >
                                      {realtorData.streetAddress}
                                      <br></br>
                                      {realtorData.cityStateZip}
                                    </a>
                                    <br></br>
                                  </>
                                ) : (
                                  ""
                                )}
                                {realtorData.branchNMLS ? (
                                  <>
                                    {realtorData.branchNMLS}
                                  </>
                                ) : (
                                  ""
                                )}
                              </p>
                            </div>
                          </Col>
                          <Col sm={12} md={12} xl={4} lg={4} className="colRealtorImage">
                            <div className="joaquinsec">
                              <img
                                src={realtorData.profileImage}
                                className="profileImg img-fluid"
                                alt={realtorName}
                              />
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}
                    </Container>
                  </div>
                </>
              </div>

            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
